/* BrandNest 5.0: native Shopify localization with an explicit UI-only fallback.
   Never machine-translates products, modifies checkout language, or changes currency. */
(() => {
  'use strict';
  const html = document.documentElement;
  const messages = window.BNMessages || {};
  const server = (html.dataset.bnServerLanguage || html.lang || 'en').split('-')[0];
  const preview = html.dataset.bnPreview === 'true';
  const key = 'brandnest-interface-language-v5';
  let current = server;
  let fallback = false;
  const originals = new WeakMap();
  const hasNative = code => !!document.querySelector(`[data-bn-lang="${code}"][data-bn-native]:not([data-bn-native=""])`);
  const readSaved = () => { try { return localStorage.getItem(key); } catch { return null; } };
  const remember = code => { try { if (code) localStorage.setItem(key, code); else localStorage.removeItem(key); } catch { /* Storage can be disabled. */ } };
  function t(id, values = {}) {
    const template = (messages[current] || messages.en || {})[id] || (messages.en || {})[id] || id;
    return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, name) => Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match);
  }
  const select = (root, selector) => [ ...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector) ];
  function refresh(root = document) {
    if (!root.querySelectorAll) return;
    select(root, '[data-bn-t]').forEach(node => {
      if (!originals.has(node)) originals.set(node, { text: node.textContent });
      let values = {};
      try { values = JSON.parse(node.dataset.bnValues || '{}'); } catch { /* Leave unparameterised. */ }
      const text = fallback || preview ? t(node.dataset.bnT, values) : originals.get(node).text;
      if (node.textContent !== text) node.textContent = text;
    });
    for (const attr of ['placeholder', 'aria-label', 'title']) {
      const dataAttr = `data-bn-i18n-${attr}`;
      select(root, `[${dataAttr}]`).forEach(node => {
        const original = originals.get(node) || {};
        if (!Object.prototype.hasOwnProperty.call(original, attr)) original[attr] = node.getAttribute(attr);
        originals.set(node, original);
        const value = fallback || preview ? t(node.getAttribute(dataAttr)) : original[attr];
        if (value !== null && node.getAttribute(attr) !== value) node.setAttribute(attr, value);
      });
    }
    const sortKeys = {manual:'sort_featured','best-selling':'sort_best','title-ascending':'sort_az','title-descending':'sort_za','price-ascending':'sort_price_up','price-descending':'sort_price_down','created-descending':'sort_date_new','created-ascending':'sort_date_old',relevance:'sort_relevance'};
    select(root, '[data-bn-sort-value]').forEach(node => {
      const original = originals.get(node) || { text: node.textContent };
      originals.set(node, original);
      const id = sortKeys[node.dataset.bnSortValue];
      const value = (fallback || preview) && id ? t(id) : original.text;
      if (node.textContent !== value) node.textContent = value;
    });
    select(root, '[data-bn-en][data-bn-ar]').forEach(node => {
      const original = originals.get(node) || { text: node.textContent };
      originals.set(node, original);
      const value = node.getAttribute(`data-bn-${current}`) || node.getAttribute('data-bn-en') || original.text;
      if (node.textContent !== value) node.textContent = value;
    });
  }
  function apply(code, persist = true) {
    if (!messages[code]) return;
    current = code;
    fallback = preview || code !== server;
    html.lang = code;
    html.dir = code === 'ar' ? 'rtl' : 'ltr';
    html.dataset.bnInterfaceLanguage = code;
    html.dataset.bnUiOnly = String(fallback && !preview);
    document.querySelectorAll('[data-bn-lang]').forEach(button => {
      const selected = button.dataset.bnLang === code;
      button.classList.toggle('is-current', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    refresh();
    document.querySelectorAll('[data-bn-language-note]').forEach(note => { note.hidden = !fallback || preview; });
    if (persist) remember(fallback && !preview ? code : null);
    document.dispatchEvent(new CustomEvent('brandnest:languagechange', { detail: { code, uiOnly: fallback } }));
  }
  window.BNLanguage = { t, refresh, apply, get code() { return current; }, get uiOnly() { return fallback; } };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-bn-lang]');
    if (!button) return;
    const code = button.dataset.bnLang;
    if (button.dataset.bnNative && !preview) {
      remember(null);
      // A standard localization form POST preserves the current page/market.
      return;
    }
    event.preventDefault();
    apply(code);
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('.bn-languages') && !preview) remember(null);
  });
  const saved = readSaved();
  if (saved && messages[saved] && !hasNative(saved)) apply(saved, false);
  else { remember(null); apply(messages[server] ? server : 'en', false); }
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE && !['SCRIPT', 'STYLE'].includes(node.tagName)) refresh(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', () => apply(current, false));
})();
